import { useContext } from "react"
import { SessionList } from "@components"
import { ContextualSidebarContext } from "@context"

const useSessionSelectorSidebar = () => {
  const { setContextualSidebar } = useContext(ContextualSidebarContext)

  const openSessionSelectorSidebar = ({
    sessions, 
    handleChangeSession,
    title = "Session Selector", 
    subTitle = `Select a session below.`,
    size = "lg",
  }) => {
    setContextualSidebar(prevState => ({
      ...prevState,
      open: true,
      title: title,
      subTitle: subTitle,
      content: <SessionList sessions={sessions} handleChangeSession={handleChangeSession} />,
      size: size,
    }))
  }

  const closeSessionSelectorSidebar = () => {
    setContextualSidebar(prev => ({ ...prev, open: false }));
  }

  return { 
    closeSessionSelectorSidebar, 
    openSessionSelectorSidebar, 
  }
}

export default useSessionSelectorSidebar